import styled from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Content = styled.div.attrs({
  className: 'gz-card__content'
}).withConfig({
  componentId: "gz-card-1673535245906__sc-1gisf41-0"
})(["padding:8px;"]);
Content.COMPONENT_ID = 'Gearz.Card.Content';
Content.displayName = Content.COMPONENT_ID;
Content.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  children: PropTypes.nodeWithDescription('Content of the card.')
};
Content.defaultProps = {
  className: '',
  children: null
};

export { Content as C };
